var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChildComponent } from '../childComponent';
import { CrossWindowCommunicationsManager, CommunicationsEvent } from '../communications/index';
import { CrossWindowContainerCommunicationHandler } from './containerCommunicationHandler';
import { generateUniqueId } from '../../../dom/document/generateIds';
import { getUrlOrigin } from '../../../dom/document/getUrlOrigin';
/**
 * Cross Window Child Component.
 */
var CrossWindowChildComponent = /** @class */ (function (_super) {
    __extends(CrossWindowChildComponent, _super);
    /**
     * Constructor.
     *
     * @param window The window reference.
     * @param options The child options.
     * @param rootFacade he root component facade.
     */
    function CrossWindowChildComponent(window, options, rootFacade) {
        var _this = _super.call(this, window, options, rootFacade) || this;
        _this.embeddedId = '';
        _this.embeddedLoadResolver = null;
        _this.embeddedErrorRejecter = null;
        _this.embeddedLoadPromise = new Promise(function (resolve, reject) {
            _this.embeddedLoadResolver = resolve;
            _this.embeddedErrorRejecter = reject;
        });
        _this.embeddedLoadHandlerRef = _this.embeddedLoadHandler.bind(_this);
        _this.embeddedErrorHandlerRef = _this.embeddedErrorHandler.bind(_this);
        return _this;
    }
    /**
     * @inheritdoc
     */
    CrossWindowChildComponent.prototype.disposeCore = function () {
        var embed = this.embeddedId
            ? this.rootElement.querySelector("#".concat(this.embeddedId))
            : null;
        if (embed) {
            embed.removeEventListener('load', this.embeddedLoadHandlerRef);
            embed.removeEventListener('error', this.embeddedErrorHandlerRef);
            // Do not remove the embedded element now as we still need it to communicate with the content.
            // The parent "rootElement" will be removed latter anyhow.
            // (<HTMLElement>embed.parentElement).removeChild(embed);
        }
        this.embeddedLoadHandlerRef = null;
        this.embeddedErrorHandlerRef = null;
        this.embeddedLoadResolver = null;
        this.embeddedErrorRejecter = null;
        this.embeddedLoadPromise = null;
        return _super.prototype.disposeCore.call(this);
    };
    /**
     * Get the CrossWindowChildComponentOptions
     */
    CrossWindowChildComponent.prototype.getOptions = function () {
        return _super.prototype.getOptions.call(this);
    };
    /**
     * @inheritdoc
     */
    CrossWindowChildComponent.prototype.mountCore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var createEmbedElementFn, embed, embedId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createEmbedElementFn = this.getOptions().createEmbedElement;
                        embed = null;
                        if (createEmbedElementFn) {
                            embed = createEmbedElementFn(this.rootElement);
                        }
                        else {
                            embed = this.createEmbedElement();
                        }
                        if (!embed)
                            throw new Error('Failed to create embed element!');
                        embedId = generateUniqueId(this.getDocument(), 'ufe-cross-');
                        embed.id = embedId;
                        this.embeddedId = embedId;
                        embed.addEventListener('load', this.embeddedLoadHandlerRef);
                        embed.addEventListener('error', this.embeddedErrorHandlerRef);
                        this.rootElement.appendChild(embed);
                        return [4 /*yield*/, (this.embeddedLoadPromise)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, _super.prototype.mountCore.call(this)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     * @param methods @inheritdoc
     */
    CrossWindowChildComponent.prototype.getCommunicationHandlerCore = function (methods) {
        var document = this.getDocument();
        var manager = new CrossWindowCommunicationsManager((document).defaultView, CommunicationsEvent.CONTENT_EVENT_TYPE, this.outboundEndpointAccessor(), CommunicationsEvent.CONTAINER_EVENT_TYPE, getUrlOrigin(document, this.getOptions().url));
        manager.initialize();
        return new CrossWindowContainerCommunicationHandler(manager, this.embeddedId, methods);
    };
    /**
     * Handle the loading of the embedded element.
     *
     * @param e The load event.
     */
    CrossWindowChildComponent.prototype.embeddedLoadHandler = function () {
        this.embeddedLoadResolver();
    };
    /**
     * Handle the error of the embedded element.
     *
     * @param e The error event.
     */
    CrossWindowChildComponent.prototype.embeddedErrorHandler = function (e) {
        this.embeddedErrorRejecter(new Error("Failed to load embedded element.\nError details:\n".concat(JSON.stringify(e))));
    };
    /**
     * Create the embedded element.
     */
    CrossWindowChildComponent.prototype.createEmbedElement = function () {
        var embed = this.getDocument().createElement('iframe');
        var opt = this.getOptions();
        if (opt.embeddedAttributes) {
            var keys = Object.keys(opt.embeddedAttributes);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                embed.setAttribute(key, opt.embeddedAttributes[key]);
            }
        }
        embed.setAttribute('src', opt.url);
        return embed;
    };
    /**
     * Access the outbound communication endpoint.
     */
    CrossWindowChildComponent.prototype.outboundEndpointAccessor = function () {
        var embed = this.embeddedId
            ? this.rootElement.querySelector("#".concat(this.embeddedId))
            : null;
        if (!embed)
            throw new Error("No iframe with \"".concat(this.embeddedId, "\" id found."));
        if (!embed.contentWindow)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error("The iframe with \"".concat(this.embeddedId, "\" id does not have a \"contentWindow\"(").concat(embed.contentWindow, ")."));
        return embed.contentWindow;
    };
    return CrossWindowChildComponent;
}(ChildComponent));
export { CrossWindowChildComponent };
//# sourceMappingURL=childComponent.js.map